export default __webpack_public_path__ + "static/media/video-bg.d440f121.png";